import { Alert, Dialog, Stack, type ButtonProps } from '@all-manager/design-system-v2';
import { type PropsWithChildren, useState } from 'react';
import { isSupabaseError } from '../../constants/supabaseErrors';

const GENERIC_ERROR = 'L’action n’a pas pu aboutir. Réessayez dans un instant.';

interface ConfirmModalProps {
  onClose: () => void;
  onConfirm: () => Promise<void>;
  color?: ButtonProps['color'];
  title?: string;
  open?: boolean;
}

export default function ConfirmModal(props: PropsWithChildren<ConfirmModalProps>) {
  const [isPending, setIsPending] = useState<boolean>(false);
  const [serverError, setServerError] = useState<string | null>(null);

  async function handleConfirm() {
    setIsPending(true);
    setServerError(null);

    try {
      await props.onConfirm();
      props.onClose();
    } catch (error) {
      setServerError(isSupabaseError(error) && error.message ? error.message : GENERIC_ERROR);
    } finally {
      setIsPending(false);
    }
  }

  function handleClose() {
    if (!isPending) {
      props.onClose();
    }
  }

  return (
    <Dialog
      open={props.open ?? true}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      title={props.title ?? 'Attention'}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Confirmer',
          color: props.color ?? 'error',
          loading: isPending,
          onClick: handleConfirm,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: handleClose,
          disabled: isPending,
        },
      }}
    >
      <Stack spacing={2}>
        {serverError ? <Alert severity="error">{serverError}</Alert> : null}
        {props.children}
      </Stack>
    </Dialog>
  );
}
